var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.276,
    height: 42.648,
    viewBox: "0 0 24.276 42.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-22.91 -2.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7128",
    "data-name": "Group 7128",
    transform: "translate(22.91 2.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4287",
    "data-name": "Path 4287",
    d: "M23.59,33.041l21.972-.068V6.19L23.59,6.258Z",
    transform: "translate(-22.43 0.122)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4288",
    "data-name": "Path 4288",
    d: "M45.562,7.169V4.712A1.54,1.54,0,0,0,44.044,3.16H25.108A1.54,1.54,0,0,0,23.59,4.712V7.237ZM32.273,4.32h4.606a.58.58,0,1,1,0,1.16H32.273a.58.58,0,1,1,0-1.16Z",
    transform: "translate(-22.43 -2.017)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4289",
    "data-name": "Path 4289",
    d: "M30.735,23.89a1.518,1.518,0,1,0,1.535,1.518A1.525,1.525,0,0,0,30.735,23.89Z",
    transform: "translate(-18.47 12.617)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4290",
    "data-name": "Path 4290",
    d: "M23.59,22.638v5.613A1.54,1.54,0,0,0,25.108,29.8H44.027a1.54,1.54,0,0,0,1.518-1.552V22.57ZM34.7,28.984a2.627,2.627,0,1,1,2.644-2.627A2.643,2.643,0,0,1,34.7,28.984Z",
    transform: "translate(-22.43 11.685)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4291",
    "data-name": "Path 4291",
    d: "M44.524,2.49H25.588A2.69,2.69,0,0,0,22.91,5.2V42.426a2.69,2.69,0,0,0,2.678,2.712H44.507a2.69,2.69,0,0,0,2.678-2.712V5.185A2.672,2.672,0,0,0,44.524,2.49Zm1.518,33.1-21.955.085V8.87l21.955-.085ZM25.588,3.633H44.507a1.54,1.54,0,0,1,1.518,1.552V7.642L24.07,7.71V5.185A1.54,1.54,0,0,1,25.588,3.633ZM44.524,43.978H25.588a1.54,1.54,0,0,1-1.518-1.552V36.813l21.955-.085v5.681A1.519,1.519,0,0,1,44.524,43.978Z",
    transform: "translate(-22.91 -2.49)",
    fill: "#47474a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4292",
    "data-name": "Path 4292",
    d: "M31.194,23.25a2.627,2.627,0,1,0,2.644,2.627A2.643,2.643,0,0,0,31.194,23.25Zm0,4.145a1.518,1.518,0,1,1,1.535-1.518A1.525,1.525,0,0,1,31.194,27.4Z",
    transform: "translate(-18.929 12.165)",
    fill: "#f95208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4293",
    "data-name": "Path 4293",
    d: "M28.92,5h4.606a.58.58,0,1,0,0-1.16H28.92a.58.58,0,1,0,0,1.16Z",
    transform: "translate(-19.077 -1.537)",
    fill: "#47474a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.d8c30e573ccf4cffedf02176953983ee.svg";
export { ForwardRef as ReactComponent };